import React from 'react';
import PropTypes from 'prop-types';
import {
	convertColorCode,
	getButtonTarget,
	getDarkerHex
} from '../../utils/buttons';

import { ButtonShape, ButtonPropertyDefaults } from '../../global-constants';

export default class TextButton extends React.Component {
	constructor(props, context) {
		const {
			buttonProps: { backgroundColor, textColor }
		} = props;
		super(props, context);
		this.state = {
			customStyles: {
				backgroundColor: convertColorCode(backgroundColor),
				color: convertColorCode(textColor)
			}
		};
	}

	/* sets backgroundColor and textColor if they exist, otherwise state remains unchanged */
	setStyles(styleObj) {
		const { backgroundColor, color } = styleObj;
		const customStyles = {};
		if (backgroundColor && color) {
			customStyles.backgroundColor = backgroundColor;
			customStyles.color = color;
		} else if (backgroundColor && !color) {
			customStyles.backgroundColor = backgroundColor;
		} else if (!backgroundColor && color) {
			customStyles.color = color;
		}
		this.setState({ customStyles });
	}

	/* gets backgroundColor and textColor if they exist, otherwise empty object is returned */
	getStyles() {
		const {
			customStyles: { backgroundColor, color }
		} = this.state;
		if (backgroundColor && color) {
			return {
				backgroundColor,
				color,
				borderColor: getDarkerHex(backgroundColor, -0.25)
			};
		} else if (backgroundColor && !color) {
			return {
				backgroundColor,
				borderColor: getDarkerHex(backgroundColor, -0.25)
			};
		} else if (!backgroundColor && color) {
			return { color };
		}
		return {};
	}

	render() {
		const { buttonProps, handleCtaClicked } = this.props;
		const {
			btnLabel,
			btnClasses,
			btnHref,
			btnTarget,
			backgroundColor,
			textColor,
			backgroundHoverColor,
			textHoverColor,
			btnAttributes
		} = buttonProps;

		const displayProps = {
			alt: btnLabel,
			style: this.getStyles()
		};

		/* if customStyling exists, update styling onMouseEnter / onMouseLeave */
		if (
			backgroundHoverColor ||
			textHoverColor ||
			backgroundColor ||
			textColor
		) {
			displayProps.onMouseEnter = _e => {
				this.setStyles({
					backgroundColor: convertColorCode(backgroundHoverColor),
					color: convertColorCode(textHoverColor)
				});
			};
			displayProps.onMouseLeave = _e => {
				this.setStyles({
					backgroundColor: convertColorCode(backgroundColor),
					color: convertColorCode(textColor)
				});
			};
		}

		return (
			<a
				className={btnClasses}
				href={btnHref}
				target={getButtonTarget(btnTarget)}
				{...displayProps}
				{...btnAttributes}
				onClick={() => {
					handleCtaClicked(btnLabel);
				}}
			>
				{btnLabel}
			</a>
		);
	}
}

TextButton.propTypes = {
	buttonProps: ButtonShape,
	handleCtaClicked: PropTypes.func
};

TextButton.defaultProps = {
	buttonProps: ButtonPropertyDefaults,
	handleCtaClicked: () => {}
};



// WEBPACK FOOTER //
// ./src/components/Buttons/TextButton.jsx